// import { tradeAccountReducers } from "../../reducers/trade/trade.account"

export const Filter = {
    filterDefaultTradingAccount,
    filterCurrentSubAccount
}

function filterDefaultTradingAccount(rawTradeData) {
    let resultData = rawTradeData.filter(traceAccount => traceAccount.isDefault)[0];
    return resultData;
}
function filterCurrentSubAccount(rawTradeData,ta){
  let resultData = []
  rawTradeData.forEach(function (item) {
    if(item.tradingAccSeq === parseInt(ta)){
      item['isDefault']=true
    }else{
      item['isDefault']=false
    }
    resultData.push(item)
  })
return resultData
}